import { cn } from '../../lib/cn';

type Props = {
  acceso: boolean;
  onCambia: (acceso: boolean) => void;
  etichetta: string;
  /** Una riga che spiega cosa succede acceso e spento. */
  spiegazione?: string;
  disabilitato?: boolean;
};

/** Interruttore acceso/spento con la sua spiegazione (nel kit dell'interfaccia non c'e'). */
export function Interruttore({ acceso, onCambia, etichetta, spiegazione, disabilitato }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={acceso}
      disabled={disabilitato}
      onClick={() => onCambia(!acceso)}
      className="flex w-full items-start gap-3 text-left disabled:opacity-50"
    >
      <span
        className={cn(
          'relative mt-0.5 inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors',
          acceso ? 'bg-primary-600' : 'bg-gray-300',
        )}
      >
        <span
          className={cn(
            'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform',
            acceso ? 'translate-x-4' : 'translate-x-0.5',
          )}
        />
      </span>
      <span className="min-w-0">
        <span className="block text-sm font-medium text-gray-900">{etichetta}</span>
        {spiegazione && <span className="block text-[11px] text-neutral-500 mt-0.5 leading-relaxed">{spiegazione}</span>}
      </span>
    </button>
  );
}
